import type { FC, ReactNode } from 'react'

import { useId } from 'react'
import { cn } from '@/lib/utils'

interface MaskMarkProps {
    variant?: 'comedy' | 'tragedy'
    tone?: 'gold' | 'silver'
    className?: string
}

const OUTLINE = 'M32 5C45.8 5 55 12.6 55 25.5C55 41.8 45 59 32 59C19 59 9 41.8 9 25.5C9 12.6 18.2 5 32 5Z'

const FEATURES = {
    comedy: [
        'M16.5 27.5C19 20.5 26 20.5 28.5 27.5C25.5 24.6 19.5 24.6 16.5 27.5Z',
        'M35.5 27.5C38 20.5 45 20.5 47.5 27.5C44.5 24.6 38.5 24.6 35.5 27.5Z',
        'M18.5 37C22 50 42 50 45.5 37C40 42.5 24 42.5 18.5 37Z'
    ],
    tragedy: [
        'M28.5 24.5C24.5 22.4 19.5 24 16.5 29.5C20.5 28.4 25.5 28.2 28.5 24.5Z',
        'M35.5 24.5C39.5 22.4 44.5 24 47.5 29.5C43.5 28.4 38.5 28.2 35.5 24.5Z',
        'M19 47C23 35.5 41 35.5 45 47C39.5 43 24.5 43 19 47Z'
    ]
}

const TONES = {
    gold: ['#f8dc97', '#e2b35c', '#a8742b'],
    silver: ['#f4f6f9', '#c9ced8', '#8a909c']
}

export const MaskMark: FC<MaskMarkProps> = ({ variant = 'comedy', tone = 'gold', className }): ReactNode => {
    const gradientId = `mask-${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`
    const [light, middle, dark] = TONES[tone]

    return (
        <svg
            viewBox='0 0 64 64'
            aria-hidden='true'
            focusable='false'
            className={cn('shrink-0', className)}
        >
            <defs>
                <linearGradient id={gradientId} x1='14' y1='6' x2='50' y2='58' gradientUnits='userSpaceOnUse'>
                    <stop offset='0' stopColor={light} />
                    <stop offset='0.5' stopColor={middle} />
                    <stop offset='1' stopColor={dark} />
                </linearGradient>
            </defs>

            <path
                fill={`url(#${gradientId})`}
                fillRule='evenodd'
                d={[OUTLINE, ...FEATURES[variant]].join(' ')}
            />
        </svg>
    )
}
